import {TogglesResponse} from './services/toggles/types/toggles-response';

export class Toggle {
  public static readonly 'INITIAL' = new Toggle('INITIAL')
  public static readonly 'UNRELEASED' = new Toggle('UNRELEASED')

  public static readonly releases = [
    Toggle.INITIAL,
    Toggle.UNRELEASED
  ]

  constructor(readonly name: string) {
  }

  public static validateToggles = (togglesToValidate: TogglesResponse) => {
    if (Toggle.releases.map(t => togglesToValidate.hasOwnProperty(t.name)).includes(false)) {
      throw new Error('Brakuje wykorzystywanego toggla.')
    }
  }
}

